<template>
  <v-dialog v-model="dialog" max-width="1200">
    <template v-slot:activator="{ props }">
      <v-btn
        size="small"
        icon="mdi-eye"
        variant="plain"
        aria-label="Preview person"
        v-bind="props"
      ></v-btn>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card elevation="0" color="background" v-if="personDashboard">
        <template #title>
          <div class="d-flex align-center ga-4">
            <div>{{ personDashboard.name }}</div>
            <div class="d-flex ga-2">
              <v-chip v-if="personDashboard.latestMembership">
                {{ personDashboard.latestMembership }}</v-chip
              >
              <v-chip
                :color="
                  personDashboard.membershipStatus?.toLowerCase() === 'inactive'
                    ? 'warning'
                    : ''
                "
              >
                {{ personDashboard.membershipStatus }}
              </v-chip>
              <v-chip
                v-if="
                  personDashboard.allowSignouts === false ||
                  personDashboard.allowSignouts === 'N'
                "
                :color="'warning'"
              >
                Admin Hold
              </v-chip>
            </div>
          </div>
        </template>

        <v-card-text>
          <v-card v-if="isLoading" elevation="0" color="background">
            <v-card-text class="d-flex align-center justify-center">
              <v-progress-circular indeterminate />
            </v-card-text>
          </v-card>

          <GeneratedPersonSummary
            :key="person.personId"
            :person="person"
            v-else-if="person"
          />
          <v-alert v-if="error" type="error" role="alert">{{ error }}</v-alert>
        </v-card-text>

        <v-card-actions class="pa-6">
          <v-btn @click="isActive.value = false">Close</v-btn>
          <v-btn
            v-if="person"
            :to="`/person/${person.personId}`"
            color="primary"
            variant="flat"
            >View Profile</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script setup lang="ts">
import { usePersonStore } from "@/stores/persons";
import { PersonDashboardData } from "@/api/dto/PersonDashboardData";
import GeneratedPersonSummary from "./GeneratedPersonSummary.vue";
import type { PersonStaff } from "../../../cbi-generator/generated/dto/PersonStaff";
import { errorMessage } from "@/composables/generated/contracts";
import { PersonDashboardTableRowData } from "@/api/dto/PersonDashboardTableRowData";

const props = defineProps<{
  personDashboard: Pick<
    PersonDashboardTableRowData,
    "personId" | "name" | "latestMembership" | "membershipStatus"
  > & {
    allowSignouts?: boolean | string | null;
  };
}>();

const personStore = usePersonStore();
const person = shallowRef<PersonStaff | null>(null);
const error = ref("");
const dialog = ref<boolean>(false);
const isLoading = ref<boolean>(false);

watch(dialog, async () => {
  if (dialog.value && props.personDashboard.personId) {
    isLoading.value = true;

    error.value = "";
    try {
      person.value = await personStore.searchPersonById(
        props.personDashboard.personId,
      );
    } catch (cause) {
      error.value = errorMessage(cause);
    } finally {
      isLoading.value = false;
    }
  }
});
</script>
